import * as types from './mutation-types';
import { RootState } from './types';
import { getLocale } from '../translations/index';

export const mutations = {
    [types.SYSTEM_ERROR](state: RootState, payload: any) {
        state.errorCode = payload.code;
        state.errorMsg = payload.message;
        state.error = true;
    },

    [types.UNEXPECTED_ERROR](state: RootState, payload: { errorCode: string; errorMsg: string }) {
        state.errorCode = payload.errorCode;
        state.errorMsg = payload.errorMsg;
        state.error = true;
    },

    [types.TOAST_MESSAGE](state: RootState, payload: { message: string }) {
        state.message = payload.message;
    },

    [types.DEAL_MESSAGE](state) {
        state.message = undefined;
    },

    [types.DEAL_ERROR](state) {
        state.errorCode = undefined;
        state.errorMsg = undefined;
        state.embedded.errorCode = undefined;
        state.embedded.errorMsg = undefined;
        state.error = false;
        state.embedded.error = false;
    },

    [types.PROCESS](state: RootState, payload: { running: boolean; msgKey: string }) {
        state.process.running = payload.running;
        state.process.msgKey = payload.msgKey;
    },

    [types.LANGUAGE](state: RootState, payload: { language: string | null }) {
        const i18n = (state as any).i18n;
        if (payload.language) {
            i18n.locale = payload.language;
        } else {
            const browserLocale = getLocale();
            i18n.locale = browserLocale.name;
        }
    },
};
